import { Airtable as EquipmentBase } from '@rogoag/airtable/equipment';
import DEFAULT_FIELDS from './default_airtable_equipment_fields.json';

const EQUIPMENT_BASE_ID = import.meta.env.VITE_AIRTABLE_EQUIPMENT_BASE_ID;

export { DEFAULT_FIELDS as equipmentBaseDefaultFields };

export const equipmentBase = new EquipmentBase({
  baseId: EQUIPMENT_BASE_ID,
  apiKey: import.meta.env.VITE_AIRTABLE_EQUIPMENT_API_KEY,
});
